import React from 'react';
import Footer from '../Fotter';

const TermsOfService = () => {
  return (
    <div>
    <div className=" mx-auto px-4 py-6">
      <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
      <h2 className="text-2xl font-semibold mt-4 mb-2">Overview</h2>
      <p className="mb-4">
        Shipping and delivery policy – Shipping will be done within 24 hours of the order placed.
      </p>
      <p className="mb-4">
        <strong>
          Discount and price you are getting for the product because you are buying product before arrival and agreed for the delayed delivery.
        </strong>
      </p>
      <p className="mb-4">
        This website is operated by bharatCod. Throughout the site, the terms “we”, “us” and “our” refer to bharatCod. bharatCod offers this website, including all information, tools and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.
      </p>
      <p className="mb-4">
        By visiting our site and/ or purchasing something from us, you engage in our “Service” and agree to be bound by the following terms and conditions (“Terms of Service”, “Terms”), including those additional terms and conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/ or contributors of content.
      </p>
      <p className="mb-4">
        Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any services. If these Terms of Service are considered an offer, acceptance is expressly limited to these Terms of Service.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 1 – Online Store Terms</h2>
      <p className="mb-4">
        By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.
      </p>
      <p className="mb-4">You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).</p>
      <p className="mb-4">You must not transmit any worms or viruses or any code of a destructive nature.</p>
      <p className="mb-4">A breach or violation of any of the Terms will result in an immediate termination of your Services.</p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 2 – General Conditions</h2>
      <p className="mb-4">We reserve the right to refuse service to anyone for any reason at any time.</p>
      <p className="mb-4">
        You understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.
      </p>
      <p className="mb-4">
        You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 3 – Accuracy, Completeness and Timeliness of Information</h2>
      <p className="mb-4">
        We are not responsible if information made available on this site is not accurate, complete or current. The material on this site is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on this site is at your own risk.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 4 – Modifications to the Service and Prices</h2>
      <p className="mb-4">Prices for our products are subject to change without notice.</p>
      <p className="mb-4">We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time.</p>
      <p className="mb-4">We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance of the Service.</p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 5 – Products or Services (if applicable)</h2>
      <p className="mb-4">
        Certain products or services may be available exclusively online through the website. These products or services may have limited quantities and are subject to return or exchange only according to our Return Policy.
      </p>
      <p className="mb-4">
        We have made every effort to display as accurately as possible the colors and images of our products that appear at the store. We cannot guarantee that your computer monitor’s display of any color will be accurate.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 6 – Accuracy of Billing and Account Information</h2>
      <p className="mb-4">
        We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 7 – Optional Tools</h2>
      <p className="mb-4">
        We may provide you with access to third-party tools over which we neither monitor nor have any control nor input.
      </p>
      <p className="mb-4">
        You acknowledge and agree that we provide access to such tools "as is" and "as available" without any warranties, representations or conditions of any kind and without any endorsement.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 8 – Third-Party Links</h2>
      <p className="mb-4">
        Certain content, products and services available via our Service may include materials from third-parties.
      </p>
      <p className="mb-4">
        We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 9 – User Comments, Feedback and Other Submissions</h2>
      <p className="mb-4">
        If, at our request, you send certain specific submissions (for example contest entries) or without a request from us you send creative ideas, suggestions, proposals, plans, or other materials, you agree that we may, at any time, without restriction, edit, copy, publish, distribute, translate and otherwise use in any medium any comments that you forward to us.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 10 – Personal Information</h2>
      <p className="mb-4">Your submission of personal information through the store is governed by our Privacy Policy.</p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 11 – Errors, Inaccuracies and Omissions</h2>
      <p className="mb-4">
        Occasionally there may be information on our site or in the Service that contains typographical errors, inaccuracies or omissions that may relate to product descriptions, pricing, promotions, offers, product shipping charges, transit times and availability.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 12 – Prohibited Uses</h2>
      <p className="mb-4">
        You are prohibited from using the site or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any laws; (d) to infringe upon or violate our intellectual property rights.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Section 13 – Disclaimer of Warranties; Limitation of Liability</h2>
      <p className="mb-4">We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure or error-free.</p>
      <p className="mb-4">
        In no case shall bharatCod, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers or licensors be liable for any indirect, incidental, punitive, special, or consequential damages.
      </p>
      <section className="mt-8">
          <h2 className="text-xl font-semibold mb-4">Customer Support</h2>
          <p>
            <strong>Address:</strong> 403, Shagun Tower, Above Apna Sweets, Scheme Number 54,P.u.4,AB Rd,vijay Nagar,Indore,Madhy Pradesh 452010
            Pradesh
          </p>
          <p>
            <strong>Phone:</strong> (+91) 9399456176
          </p>
          <p>
            <strong>E-mail:</strong> info@bharatCod.com
          </p>
          <p>
            <strong>Website:</strong>{" "}
            <a
              href="http://www.bharatCod.com"
              className="text-blue-500 underline"
            >
              www.bharatCod.com
            </a>
          </p>
          <div className="mb-10 flex  space-x-6">
            <a
              href="https://www.facebook.com/thebharatcod"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook fa-2x text-blue-600 hover:text-blue-800"></i>
            </a>
            <a
              href="https://www.instagram.com/bharatcod/#"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram fa-2x text-pink-500 hover:text-pink-700"></i>
            </a>
            <a
              href="https://in.pinterest.com/thebharatcod/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-pinterest fa-2x text-blue-700 hover:text-blue-900"></i>
            </a>
            <a
              href="https://www.youtube.com/channel/UC5TRs6-BjCd9QgDbP8YKvEQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube fa-2x text-red-700 hover:text-red-700"></i>
            </a>
          </div>
        </section>
    </div>
      <Footer />
      </div>

  );
};

export default TermsOfService;
